import styles from './Flag.module.css'
import { flags } from "@/i18n/constants"
import { ComponentType, SVGProps } from 'react'

export enum FlagSize {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small'
}

interface FlagProps extends React.HTMLAttributes<HTMLDivElement> {
  locale: keyof typeof flags,
  size: FlagSize,
  selected?: boolean
  disabled?: boolean
}

export default function Flag ({ locale, size, className, selected, disabled, onClick }: FlagProps) {
  const FlagIcon: ComponentType<SVGProps<SVGSVGElement>> | undefined = flags[locale]
  
  return (
    <div
      className={`${styles.flag} ${size} ${selected ? styles.selected : ''} ${disabled ? styles.disabled : ''} ${className ?? ''}`}
      onClick={onClick}
      data-testid={`Flag_${locale}`}
    >
      {FlagIcon ? <FlagIcon /> : null}
    </div>
  )
}